import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const CustomMessage = ({ message, variant }) => {
  return (
    <Typography
      variant="body2"
      color={variant ? `${variant}` : 'info'}
      sx={{ textAlign: 'center', marginBottom: 2 }}
    >
      {message}
    </Typography>
  );
};

CustomMessage.propTypes = {
  message: PropTypes.string.isRequired,
  variant: PropTypes.string,
};

export default CustomMessage;
